/**
 * 多级审核页面接口
 */
import { request } from '../request'

/**
 * 查询审核层级
 * @param id 问卷id
 * @return {Promise}
 */
export function getAudit(id) {
  return request({
    url: '/wenjuanLogic/multiAudit/list',
    method: 'get',
    params: {
      id
    }
  })
}

/**
 * 添加审核层级
 * @param data
 * @return {Promise}
 */
export function addAudit(data) {
  return request({
    url: '/wenjuanLogic/multiAudit/addLevel',
    method: 'post',
    data
  })
}

/**
 * 修改审核层级 / 添加审核员
 * @param data
 * @return {Promise}
 */
export function setAudit(data) {
  return request({
    url: '/wenjuanLogic/multiAudit/editLevel',
    method: 'post',
    data
  })
}

/**
 * 删除审核层级
 * @param params
 * @return {Promise}
 */
export function delAudit(params) {
  return request({
    url: '/wenjuanLogic/multiAudit/removeLevel',
    method: 'get',
    params
  })
}

/**
 * 覆盖审核层级
 * @param id 问卷 Id
 * @param data
 * @return {Promise}
 */
export function overwriteLevels(id, data) {
  return request({
    url: `/wenjuanLogic/multiAudit/overwriteLevels`,
    method: 'post',
    params: { id },
    data
  })
}

export function fixTask(id) {
  return request({
    url: '/answer/multiAudit/fixTask',
    method: 'get',
    params: { surveyId: id }
  })
}
